import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-totalexperiencevideo-card',
  templateUrl: './helpbutton-reports-totalexperiencevideo-card.component.html',
  styleUrls: ['./helpbutton-reports-totalexperiencevideo-card.component.scss']
})
export class HelpbuttonReportsTotalexperiencevideoCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
